import { useSelector } from 'react-redux';

import type { FeatureFlag } from 'app/api/services/site-configs/types';
import type { ReduxState } from 'app/redux/types';

import { getFeatureFlags } from 'app/lib/site-configs/selectors';

export const useLocalFeatureFlags = () => {
  const localFeatureFlags = useSelector(
    (state: ReduxState) => getFeatureFlags(state),
  );
  const hasFeatureFlag = (featureFlag: FeatureFlag) => {
    return localFeatureFlags.includes(featureFlag);
  };

  return { hasFeatureFlag };
};
